import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  confirmationDropdownPlaceholder: {
    id: '0ngoTa',
    defaultMessage: 'Select a confirmation type',
    description: 'Placeholder for the delivery confirmation dropdown in the workflow action editor',
  },
  customsContentDropdownPlaceholder: {
    id: 'MygCpi',
    defaultMessage: 'Select a content type',
    description: 'Placeholder for the customs content type dropdown in the workflow action editor',
  },
  deliveryTemplateDropdownPlaceholder: {
    id: 'jNEU9j',
    defaultMessage: 'Select a template',
    description: 'Placeholder for the delivery notification template dropdown in the workflow action editor',
  },
  fulfillmentServiceDropdownPlaceholder: {
    id: '0MJ3O7',
    defaultMessage: 'Select a fulfillment service',
    description: 'Placeholder for the fulfillment service dropdown in the workflow action editor',
  },
  nonDeliveryDropdownPlaceholder: {
    id: 'TcQfCA',
    defaultMessage: 'Select a non-delivery option',
    description: 'Placeholder for the international non-delivery dropdown in the workflow action editor',
  },
  packingSlipDropdownPlaceholder: {
    id: 'XhvL4N',
    defaultMessage: 'Select a packing slip',
    description: 'Placeholder for the packing slip dropdown in the workflow action editor',
  },
  shipmentTemplateDropdownPlaceholder: {
    id: '/MZF4J',
    defaultMessage: 'Select a template',
    description: 'Placeholder for the shipment notification template dropdown in the workflow action editor',
  },
  userDropdownPlaceholder: {
    id: 'XmJbIb',
    defaultMessage: 'Select a user',
    description: 'Placeholder for the user dropdown in the workflow action editor',
  },
  warehouseDropdownPlaceholder: {
    id: 'PtXBEl',
    defaultMessage: 'Select a ship-from location',
    description: 'Placeholder for the ship-from location dropdown in the workflow action editor',
  },
  insuranceDropdownPlaceholder: {
    id: 'ZC6COq',
    defaultMessage: 'Select an insurance provider',
    description: 'Placeholder for the insurance provider dropdown in the workflow action editor',
  },
  insuranceCarrierEndingSupport: {
    id: 'CJ9gk7',
    defaultMessage: 'Carrier (Support Ending Soon)',
    description: 'Insurance dropdown option label when carrier insurance support is ending soon',
  },
  insuranceCarrierUnsupported: {
    id: 'cw6y0p',
    defaultMessage: 'Carrier (Unsupported)',
    description: 'Insurance dropdown option label when carrier insurance is no longer supported',
  },
});
